export enum UserVerificationState {
  EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
  PHONE_NUMBER_NOT_VERIFIED = 'PHONE_NUMBER_NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
  NOT_EXISTS = 'NOT_EXISTS',
}
